import { Outlet } from 'react-router';
import { EGText } from '@/components/eg/eg-text';

const chips = ['Simple to use', 'Start small, scale fast', 'Seamless experience', 'Secure data storage'];

export default function AuthLayout() {
  return (
    <div className="grid grid-cols-2">
      <div className="h-screen bg-cover bg-center p-[80px]" style={{ backgroundImage: "url('/images/bg-login.png')" }}>
        <div className="flex h-full flex-col">
          <div className="mr-2 w-[200px] pb-[140px]">
            <img src="/assets/images/helix-star-logo.svg" alt="Easy Genomics" className="brightness-0 invert" />
          </div>

          <div className="font-schibsted max-w-[400px] text-[46px] leading-[64px] font-medium text-white">
            Genomic Insights Made Effortless
          </div>

          <div className="grow" />

          <div className="font-schibsted flex flex-row flex-wrap gap-3">
            {chips.map((chip) => (
              <div key={chip} className="rounded-full bg-[#ffffff33] px-5 py-2 text-2xl font-medium text-white">
                {chip}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex min-h-screen flex-col">
        <div className="flex flex-grow flex-col items-center justify-center">
          <Outlet />
        </div>
        <footer className="border-stroke-light flex w-full justify-end gap-5 border-t border-solid px-12 py-6 text-center text-sm leading-5">
          <EGText tag="a" colorClass="text-muted" href="mailto:contact@cariva.co.th">
            Contact Helix Star*
          </EGText>
        </footer>
      </div>
    </div>
  );
}
